import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { datadogRum } from '@datadog/browser-rum';
import { initializeRealUserMonitoring } from '@eb/real-user-monitoring';

import { middleware as analyticsMiddleware } from '@eb/site-analytics';
import { configureStore } from '@eb/redux-configure-store';

import { BasePage } from '../base';

import { getInitialData } from '../../redux/reducers/utils';
import reducer from '../../redux/reducers';

import { ConsumerHeader } from '../../components/ConsumerHeader';
import { isProd } from '../../utils/http';

import { CityBrowseBaseScreenContainer } from './containers';

import './BrowsePage.scss';
import '../app.scss';

class BrowsePage extends React.Component {
    constructor(props) {
        super(props);

        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    componentDidMount() {
        const { env } = this.props;

        if (isProd({ env })) {
            initializeRealUserMonitoring({
                sampleRate: 2.5,
                version: this.props.app_version,
                service: this.props.app_name,
            });

            datadogRum.onReady(() =>
                datadogRum.addRumGlobalContext('view.sub_app', 'browse'),
            );
        }
    }

    render() {
        return (
            <Provider store={this._store}>
                <BasePage {...this.props} structureHeader={ConsumerHeader}>
                    <div className="feed-browse-page">
                        <CityBrowseBaseScreenContainer {...this.props} />
                    </div>
                </BasePage>
            </Provider>
        );
    }
}

export default BrowsePage;
